import { PureComponent, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import RatingEstimatesForm from "../../components/exams/rating-estimates-form/RatingEstimatesForm";
import RatingEstimatesList from "../../components/exams/rating-estimates-list/RatingEstimatesList";
import RatingEstimatesPercentageCourses from "../../components/exams/rating-estimates-percentage-courses/RatingEstimatesPercentageCourses";
import { RatingEstimatesCourseType } from "../../components/exams/rating-estimates-percentage-courses/RatingEstimatesPercentageCourses.models";
import RatingEstimatesRealResultsList from "../../components/exams/rating-estimates-real-results-list/RatingEstimatesRealResultsList";
import { ExamWorkBookGroups } from "../../models/interfaces/exams/rating-estimates/ExamWorkBookGroups";
import { ExamWorkBookQueryString } from "../../models/query-strings/exams/rating-estimates/ExamWorkBookQueryString";
import { WorkBookQueryString } from "../../models/query-strings/exams/rating-estimates/WorkBookQueryString";
import WorkBookService from "../../services/exam/WorkBookService";
import WorkBookRouteStates from "./WorkBookRoute.models";

export default class WorkBookRoute extends PureComponent<{}, WorkBookRouteStates>{

    workBookService: WorkBookService;
    constructor(props: any) {
        super(props);
        this.workBookService = new WorkBookService();
        this.state = { step: 1, departementGroup: 0, year: 100, WorkBooks: [], query: { departementGroup: 0, year: 100 }, datas: [], navigator: false };
    }

    changeStep = () => {
        this.setState({ step: this.state.step + 1 });
    }
    onChangeDept = (value: any) => {
        this.setState({ departementGroup: value as ExamWorkBookGroups });
    }
    onChangeYear = (value: any) => {
        this.setState({ year: value });
    }
    onChangePrecent = (data: RatingEstimatesCourseType) => {
        var query = this.state.query;
        switch (data.label) {
            case 'ادبيات':
                return query.literature = this.calculator(data.value);
            case 'عربي':
                return query.arabic = this.calculator(data.value);
            case 'دینی':
                return query.religious = this.calculator(data.value);
            case 'زبان':
                return query.language = this.calculator(data.value);
            case 'رياضي':
                return query.math = this.calculator(data.value);
            case 'فيزيك':
                return query.physics = this.calculator(data.value);
            case 'شيمي':
                return query.chemistry = this.calculator(data.value);
            case 'زيست ‌شناسي':
                return query.biology = this.calculator(data.value);
            case 'اقتصاد':
                return query.economy = this.calculator(data.value);
            case 'ادبيات اختصاصي':
                return query.dedicatedLiterature = this.calculator(data.value);
            case 'عربي اختصاصي':
                return query.dedicatedArabic = this.calculator(data.value);
            case 'تاريخ و جغرافي':
                return query.historyAndGeography = this.calculator(data.value);
            case 'علوم اجتماعي':
                return query.socialSciences = this.calculator(data.value);
            case 'فلسفه و منطق':
                return query.philosophyAndLogic = this.calculator(data.value);
            case 'روانشناسي':
                return query.psychology = this.calculator(data.value);
        }
        this.setState({ query: query });
        this.forceUpdate()
    }
    getFirstExams = (datas: RatingEstimatesCourseType[]) => {
        datas.forEach(element => {
            this.onChangePrecent(element);
        });
        
        let query: WorkBookQueryString = this.state.query;
        query.departementGroup = this.state.departementGroup;
        query.year = this.state.year;


        this.workBookService.getPaged(query).then(response => {
            this.setState({ WorkBooks: response, step: 3 });
        });

    }

    calculator = (value: number) => {
        if (value <= 0) {
            return 0;
        }
        else if (value >= 5 && value < 15) {
            return 1;
        }
        else if (value >= 15 && value < 25) {
            return 2;
        }
        else if (value >= 25 && value < 35) {
            return 3;
        }
        else if (value >= 35 && value < 45) {
            return 4;
        }
        else if (value >= 45 && value < 55) {
            return 5;
        }
        else if (value >= 55 && value < 65) {
            return 6;
        }
        else if (value >= 65 && value < 75) {
            return 7;
        }
        else if (value >= 75 && value < 85) {
            return 8;
        }
        else if (value >= 85 && value < 95) {
            return 9;
        }
        else if (value >= 95) {
            return 10;
        }
    }

    getRealData = (rank: number, qGroup: any) => {

        var query: ExamWorkBookQueryString = { departementGroup: this.state.departementGroup, rank: rank, year: this.state.year, quotaGroup: qGroup };
        this.workBookService.getWorkBooks(query).then(response => {
            this.setState({ datas: response, step: 4 });
        });
    }

    backMenu = () => {

        if (this.state.step === 1) {
            this.setState({ navigator: true });
        }
        else {
            this.setState({ step: this.state.step - 1 })
        }
    }

    render(): ReactNode {
        let { step, departementGroup, year, datas, WorkBooks, navigator } = this.state;
        let content = <></>;

        switch (step) {
            case 2:
                content = <RatingEstimatesPercentageCourses dept={departementGroup as number} handleRequest={this.getFirstExams} onPrecentChangeHandle={this.onChangePrecent} />;
                break;
            case 3:
                content = <RatingEstimatesList handleRequest={this.getRealData} WorkBooks={WorkBooks} />;
                break;
            case 4:
                content = <RatingEstimatesRealResultsList datas={datas} />;
                break;
            default:
                content = <RatingEstimatesForm config={{ departementGroup: departementGroup, year: year, onChangeStep: this.changeStep, onChangeGroup: this.onChangeDept, onChangeYear: this.onChangeYear }} />;
                break
        }
        return <>
            {navigator && <Navigate to={"/Exams"}></Navigate>}

            <a onClick={this.backMenu} style={{
                position: "absolute",
                top: "-50px",
                left: "26px",
                color: "#ffffff",
            }} className="back-icon pd-top-8">
                <label className={"mdi f-26 mdi-arrow-left"} ></label>
            </a>

            {content}
        </>
    }
}